<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Resume' }" tag="li" class="breadcrumb-item">
						<a href="#">履歷表</a>
					</router-link>
				</ol>
			</nav>
			<div class="modal fade" id="popBox" tabindex="-1" role="dialog" aria-labelledby="popBoxLabel" aria-hidden="true">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="popBoxLabel">{{ popMsg.title }}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div v-html="popMsg.content"></div>
						</div>
						<div class="modal-footer">
							<button type="button" class="pcbtn" data-dismiss="modal">關閉</button>
						</div>
					</div>
				</div>
			</div>
			<div class="modal fade" id="Resume" tabindex="-1" role="dialog" aria-labelledby="ResumeLabel" aria-hidden="true">
				<div class="modal-dialog modal-xl" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="ResumeLabel">圖片</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body text-center">
							<a id="resume-append" href="" download="pcrd-resume"></a>
						</div>
						<div class="modal-footer">
							<button type="button" class="pcbtn" data-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
			<div class="item-box">
				<h3 class="item-title">{{ $t("Preview") }}</h3>
				<div class="row mb-3" id="resume-start">
					<div class="col-12 mb-3">
						<div id="resume-wrap" ref="capture" :style="'border-color:' + borderC">
							<div class="resume-box" :style="isKvChara">
								<!-- <div class="game-logo">
									<img src="/static/images/gamelogo.png">
								</div> -->
								<div class="player-info-box">
									<div class="row">
										<div class="col-12">
											<div class="info-item mb-3">
												<span :style="'background-color:' + tagC" class="title">
													{{ $t("Server") }}
												</span>
												<span class="value">
													{{ playerStatus.server }}
												</span>
											</div>
										</div>
										<div class="col-12">
											<div class="info-item mb-3">
												<span :style="'background-color:' + tagC" class="title">
													{{ $t("Nickname") }}
												</span>
												<span class="value">
													{{ playerStatus.name }}
												</span>
											</div>
										</div>
										<div class="col-12">
											<div class="info-item mb-3">
												<span :style="'background-color:' + tagC" class="title">
													{{ $t("Level") }}
												</span>
												<span class="value">
													{{ playerStatus.level }}
												</span>
											</div>
										</div>
										<div class="col-12">
											<div class="info-item mb-3">
												<span :style="'background-color:' + tagC" class="title">
													{{ $t("CPower") }}
												</span>
												<span class="value">
													{{ playerStatus.power }}
												</span>
											</div>
										</div>
										<div class="col-12">
											<div class="info-item mb-3">
												<span :style="'background-color:' + tagC" class="title">
													{{ $t("PlayStyle") }}
												</span>
												<span class="value">
													{{ playerStatus.howToPlay }}
												</span>
											</div>
										</div>
										<div class="col-12">
											<div class="info-item long mb-3">
												<span class="title long" :style="'background-color:' + tagC">
													{{ $t("SelfIntroduction") }}
												</span>
												<span class="value long" style="border: none">
													<div v-html="playerStatus.intro.replace(/\n/g, '<br/>')" v-if="playerStatus.intro"></div>
													<div v-else></div>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="player-box-box mt-3" v-if="playerStatus.teamList.length > 0">
								<div class="unit-box">
									<div class="info-item">
										<span :style="'background-color:' + tagC" class="title">{{$t('Unit')}}</span>
									</div>
									<div class="d-flex flex-wrap my-3 justify-content-lg-start justify-content-center" id="team-list-box">
										<div
											class="p-1 armory-box mb-1 armory-item-box"
											v-for="item in playerStatus.teamList"
											:class="item.lvBreak == 'true' ? 'lv-break' : ''"
											@click="changeKv(item)"
										>
											<div class="armory-img-box edit-box gacha-item" :class="checkPromo(item.promotion_level, item.trace)">
												<img
													:src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 10) + '.png'"
													alt=""
													v-if="item.rarity < 3"
												/>
												<img
													v-else-if="item.rarity <= 5 && item.rarity >= 3"
													:src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
													alt=""
												/>
												<img v-else :src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 60) + '.png'" alt="" />
												<div class="star-box" v-if="item.rarity != 6">
													<span v-for="n in 5" class="rarity">
														<img src="/static/images/star.png" v-if="n <= Number(item.rarity)" />
														<img src="/static/images/star_dark.png" v-else />
													</span>
												</div>
												<div class="star-box" v-else>
													<span class="rarity pink">
														<img src="/static/images/star_pink.png" width="15px" />
													</span>
												</div>
												<div class="uq-mark" v-if="item.uqEq > 0">
													<img src="/static/images/uneq.png" />
												</div>
											</div>
											<div class="text-center">Rank{{ item.promotion_level }}<br /></div>
										</div>
									</div>
								</div>
								<!-- <div class="unit-none-box mt-3" v-if="!checkNotExist()">
									<div class="info-item">
										<span :style="'background-color:' + tagC" class="title">沒有的角色</span>
									</div>
									<div class="d-flex flex-wrap">
										<div class="unit-box p-1 mr-1 mb-1" v-for="item in playerStatus.teamList" v-if="item.notExist != '0'">
											<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
										</div>
									</div>
								</div> -->
							</div>
							<div class="author text-center mt-3">
								https://pcredivewiki.tw
							</div>
						</div>
					</div>

					<div class="col-12 my-1">
						<div class="my-3">
							<button class="pcbtn mr-3 mb-3" @click="loadFromArmory">{{ $t("LoadFromArmory") }}</button>
							<button class="pcbtn primary mr-3 mb-3" @click="start">{{ $t("MadeImage") }}</button>
						</div>
					</div>
					<div class="col-12">
						<div class="row">
							<div class="col-md-6 col-12 my-1">
								<label for="">{{$t('BorderColor')}}</label>
								<div class="input-group">
									<input type="text" class="form-control" placeholder="#acc8f5" v-model="borderC" />
									<div class="input-group-append position-relative">
										<div
											style="background: linear-gradient( limegreen, transparent ), linear-gradient( 90deg, skyblue, transparent ), linear-gradient( -90deg, coral, transparent );background-blend-mode: screen;"
											class="input-group-text cursor-pointer"
											@click="pickBorder = !pickBorder"
										>
											@
										</div>
									</div>
								</div>
								<div v-if="pickBorder" style="" class="d-block">
									<chrome-picker :value="borderColors" @input="updateBorderValue"></chrome-picker>
								</div>
							</div>
							<div class="col-md-6 col-12 my-1">
								<label for="">{{$t('TagColor')}}</label>
								<div class="input-group position-relative">
									<input type="text" class="form-control" v-model="tagC" @click="pickTag = true" />
									<div class="input-group-append position-relative">
										<div
											style="background: linear-gradient( limegreen, transparent ), linear-gradient( 90deg, skyblue, transparent ), linear-gradient( -90deg, coral, transparent );background-blend-mode: screen;"
											class="input-group-text cursor-pointer"
											@click="pickTag = !pickTag"
										>
											@
										</div>
									</div>
								</div>
								<div v-if="pickTag" class="d-block">
									<chrome-picker :value="tagColors" @input="updateTagValue"></chrome-picker>
								</div>
							</div>
						</div>
						<div class="form-row align-items-center">
							<div class="col-md-6 col-12 my-1">
								<label for="nowLv">{{ $t("Nickname") }}</label>
								<input type="text" class="form-control" placeholder="名稱" v-model="playerStatus.name" />
							</div>
							<div class="col-md-6 col-12 my-1">
								<label for="targeLv">{{ $t("Level") }}</label>
								<div class="input-group">
									<input type="number" class="form-control" placeholder="等級" v-model="playerStatus.level" />
								</div>
							</div>
							<div class="col-md-6 col-12 my-1">
								<label for="targeLv">{{ $t("CPower") }}</label>
								<div class="input-group">
									<input type="number" class="form-control" placeholder="over 9000" v-model="playerStatus.power" />
								</div>
							</div>
							<div class="col-md-6 col-12 my-1">
								<label for="targeLv">{{ $t("Server") }}</label>
								<div class="input-group">
									<input type="text" class="form-control" placeholder="美食" v-model="playerStatus.server" />
								</div>
							</div>
							<div class="col-md-6 col-12 my-1">
								<label for="targeLv">{{ $t("PlayStyle") }}</label>
								<div class="input-group">
									<input type="text" class="form-control" placeholder="遊玩方針" v-model="playerStatus.howToPlay" />
								</div>
							</div>
							<div class="col-12 my-1">
								<label for="targeLv">{{ $t("SelfIntroduction") }}</label>
								<div class="input-group">
									<textarea v-model="playerStatus.intro" style="height: 10rem" class="form-control"></textarea>
								</div>
							</div>
							<!-- <div class="col-12 my-1">
								<h3 class="item-title">持有角色</h3>
								<div class="my-3">
									<button class="pcbtn mr-3 mb-3" @click="loadFromArmory">{{$t('LoadFromArmory')}}</button>
									<button class="pcbtn primary mr-3 mb-3" @click="start">{{$t('MadeImage')}}</button>
								</div>
								<div class="d-flex flex-wrap mb-3">
									<div class="resume-select-box mr-3 mb-3" v-for="(item,index) in unit_data" :key="item.unit_id" :style="checkStyle(item)">
										<div class="row">
											<div class="col-12 mb-3">
												<div class="armory-img-box gacha-item star3">
													<img :src="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" alt="">
												</div>
											</div>
											<div class="col-12">
												<div class="form-group row">
													<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
														姓名
													</label>
													<div class="col-sm-9">
														{{item.kana}}
													</div>
												</div>
												<div class="form-group row">
													<label for="f2" class="col-sm-3 col-form-label col-form-label-sm">
														封面
													</label>
													<div class="col-sm-9">
														<select class="form-control form-control-sm" v-model="item.isKv" v-on:change="changeKv(item)">
															<option value="0" selected="selected">否</option>
															<option value="1">是</option>
															<option value="2">六星</option>
														</select>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import domtoimage from "dom-to-image";
import { Chrome } from "vue-color";
let defaultProps = {
	hex: "#acc8f5",
};
let defaultPropsTitle = {
	hex: "#f55291",
};
export default {
	name: "Resume",
	data() {
		return {
			playerStatus: {
				kv_unit_id: "104661",
				name: "佑樹11",
				level: "154",
				power: "1234567",
				howToPlay: "保500",				
				server: "美食",
				intro: "每天上線\n公會戰打滿3刀\n輕鬆玩遊戲",
				teamList: {},
			},
			borderColors: defaultProps,
			tagColors: defaultPropsTitle,
			pickBorder: false,
			kv_unit_id: "104661",
			pickTag: false,
			styleColor: "#acc8f5",
			unit_data: {},
			popMsg: {
				title: "",
				content: "",
			},
		};
	},
	props: ["clientWidth"],
	components: {
		"chrome-picker": Chrome,
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: "履歷表",
		// all titles will be injected into this template
		titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
	},
	methods: {
		updateBorderValue(value) {
			this.borderColors = value;
			this.$forceUpdate();
		},
		updateTagValue(value) {
			this.tagColors = value;
			this.$forceUpdate();
		},
		start: function() {
			var self = this;
			$("#resume-append").html("");
			var node = document.getElementById("resume-wrap");
			domtoimage
				.toPng(node)
				.then(function(dataUrl) {
					var img = new Image();
					img.src = dataUrl;
					$("#resume-append").append(img);
					$("#resume-append").attr("href", dataUrl);
				})
				.catch(function(error) {
					console.error("oops, something went wrong!", error);
				});
			$("#Resume").modal();
			// var playUnitList = _.filter(self.unit_data, function(o) {
			// 	return o.notExist == true || o.uqEq != "0" || o.isKv != "0";
			// })
			//self.playerStatus.teamList = playUnitList;
			localStorage.setItem("playerStatus", JSON.stringify(self.playerStatus));
		},
		loadFromArmory: function() {
			var self = this;
			var resumeTeamList = [];
			var myTeamList = JSON.parse(localStorage.getItem("teamList"));
			_.forEach(myTeamList, function(o) {
				var obj = {};
				var unit = _.find(self.$store.getters.getUnitData, ["unit_id", o.unit_id]);
				obj.search_area_width = unit.search_area_width ? unit.search_area_width : "900";
				obj.unit_id = o.unit_id;
				obj.promotion_level = o.promotion_level ? o.promotion_level : "1";
				obj.uqEq = o.uqEq ? o.uqEq : "0";
				obj.lvBreak = o.lvBreak ? o.lvBreak : "false";
				obj.rarity = o.rarity ? Number(o.rarity) : 1;
				resumeTeamList.push(obj);
			});
			resumeTeamList = _.orderBy(resumeTeamList, ["search_area_width"], ["asc"]);
			// self.unit_data = _.forEach(self.unit_data, function(item) {
			// 	var unit = _.find(resumeTeamList, ["unit_id", item.unit_id]);
			// 	if (unit) {
			// 		item.lvBreak = unit.lvBreak;
			// 		item.promotion_level = unit.promotion_level;
			// 		item.rarity = Number(unit.rarity);
			// 		item.trace = unit.trace;
			// 		item.uqEq = unit.uqEq;
			// 	}
			// })
			self.playerStatus.teamList = resumeTeamList;
			$("#popBox").modal();
			self.popMsg.title = "讀取裝備庫";
			
			self.popMsg.content = this.$t('LoadFromArmory')+ ' ' + this.$t('Success');
		},
		checkNoEq: function() {
			var unit_list = this.unit_data;
			var notExistList = _.filter(unit_list, (obj) => obj.uqEq != 0);
			return _.isEmpty(notExistList);
		},
		checkNotExist: function() {
			var unit_list = this.unit_data;
			var notExistList = _.filter(unit_list, (obj) => obj.notExist != 0);
			return _.isEmpty(notExistList);
		},
		checkStyle: function(item) {
			var style = "";
			if (item.notExist) {
				style += "background-color: #e9e9e9;";
			}
			if (item.isKv != 0) {
				style += "border: 3px solid #f55291";
			}
			return style;
		},
		changeKv: function(item) {
			if (item.rarity <= 5) {
				this.kv_unit_id = (Number(item.unit_id) + 30).toString();
				this.playerStatus.kv_unit_id = (Number(item.unit_id) + 30).toString();
			} else {
				this.kv_unit_id = (Number(item.unit_id) + 60).toString();
				this.playerStatus.kv_unit_id = (Number(item.unit_id) + 60).toString();
			}
		},
		setPlayerStaus: function(jsonObj) {			
			let getKV = jsonObj.kv_unit_id  ? jsonObj.kv_unit_id  : "104661"
			this.playerStatus.kv_unit_id = getKV
			this.kv_unit_id = getKV
			this.playerStatus.name = jsonObj.name
			this.playerStatus.level = jsonObj.level
			this.playerStatus.power = jsonObj.power
			this.playerStatus.howToPlay = jsonObj.howToPlay
			this.playerStatus.server = jsonObj.server
			this.playerStatus.intro = jsonObj.intro
			this.playerStatus.teamList = jsonObj.teamList
		},
		checkPromo: function(value, isTrace) {
			if (isTrace == "false") {
				return "notTrace";
			}
			if (value >= 24) {
				return "p8";
			} else if (value < 24 && value >= 21) {
				return "p7";
			} else if (value < 21 && value >= 18) {
				return "p6";
			} else if (value < 18 && value >= 11) {
				return "p5";
			} else if (value < 11 && value >= 7) {
				return "p4";
			} else if (value < 7 && value > 3) {
				return "p3";
			} else if (value > 1 && value < 4) {
				return "p2";
			} else if (value == 1) {
				return "p1";
			}
		},
	},
	created: function() {
		var self = this;
		var unit_data = new Array();
		// _.forEach(self.$store.getters.getUnitData, function(value) {
		// 	_.forEach(self.$store.getters.getCharaIdentity, function(o) {
		// 		if (o.unit_id == value.unit_id && value.cutin_1 != "0") {
		// 			var obj = {};
		// 			obj.unit_id = value.unit_id;
		// 			obj.search_area_width = value.search_area_width;
		// 			unit_data.push(obj);
		// 		}
		// 	});
		// });

		// self.unit_data = _.orderBy(unit_data, ['search_area_width', 'unit_id'], ['asc', 'desc']);
		if (localStorage.getItem("playerStatus") != null) {
			var status = localStorage.getItem("playerStatus");
			let statusToJson = JSON.parse(status);
			this.setPlayerStaus(statusToJson)
		}
	},
	computed: {
		unitList: function() {
			var self = this;
			var unitData = self.unit_data;
			// if (!_.isEmpty(self.playerStatus.teamList)) {
			// 	unitData = _.forEach(unitData, function(item) {
			// 		var unit = _.find(self.playerStatus.teamList, ["unit_id", item.unit_id]);
			// 		if (unit) {
			// 			item.notExist = unit.notExist;
			// 		}
			// 	})
			// }
			return unitData;
		},
		borderC: function() {
			return this.borderColors.hex;
		},
		tagC: function() {
			return this.tagColors.hex;
		},
		isKvChara: function() {
			var self = this;
			var bgId = this.kv_unit_id;
			return `background-image: linear-gradient(to right, rgba(255,255,255,0) 75%,rgba(255,255,255,1)),url(/static/images/unit_big/unit_big_${bgId}.jpg)`;
		},
	},
	mounted: function() {
		var self = this;
		if (this.clientWidth < 1000) {
			$("#resume-start").html("<div class='col-12'>此功能暫時不支援手機板 not supported on mobile devices</div>");
		}		
		this.loadFromArmory();
	},
};
</script>
<style lang="sass" scoped></style>
